import { BasicSVG } from "../basicsvg.js";
import i18next from "i18next";
/**
 * @class MSPolygon
 * @extends BasicSVG
 * @classdesc Полигон
 * */
export class MSPolygon extends BasicSVG {
    static get observedAttributes() {
        return super.observedAttributes.concat([
            "bordergeometry",
            "eventcontur",
            "borderticknesshover",
            "bordercolorhover",
            "z",
        ]);
    }

    constructor() {
        super();
        this._createInnerSVG("path");
        this._path.setAttribute("shape-rendering", "geometricPrecision");
        this._path.setAttribute("vector-effect", "non-scaling-stroke");
        this.borderthickness = 2;
        this._d = "M0,0";
        this._geometryMode = "init";
        this._polygonClickHandler = this._handlePolygonContur.bind(this);
        this._polygonHoverHandler = this._handlePolygonConturHover.bind(this);
        this._polygonDbClickHandler = this._handlePolygonConturDbClick.bind(this);
        this.observePathSize();
    }

    // Из-за Bug 20972: Примитивы не отображаются при переключении видимости экземпляра окна, если начальное значение видимости=False
    // функция afterInitialize() закоменчена
    //afterInitialize() {
    //    this._path.setAttribute('d', this._d);
    //    const size = this._path.getBBox();
    //    this._main.setAttribute('viewBox', `${size.x} ${size.y} ${size.width} ${size.height}`);
    //    this._resource && (this.resource = this._resource);
    //}

    get z() {
        return this._z;
    }

    set z (value) {
        this._z = +value;
        this.style.zIndex = this._z;
    }

    get bordercolorhover() {
        return this._bordercolorhover;
    }

    set bordercolorhover(value) {
        this._bordercolorhover = value;
    }

    get borderticknesshover() {
        return this._borderthicknesshover;
    }

    set borderticknesshover(value) {
        this._borderthicknesshover = value;
    }

    get width() {
        return this._width;
    }

    set width(value) {
        this._width = value;
        const tmp = Number(value);
        if (tmp) {
            this.style.width = this._setValueUnit(value);
            this._main.setAttribute("width", this._setValueUnit(value));
        }
    }

    get eventcontur() {
        return this._eventcontur;
    }

    set eventcontur(value) {
        this._eventcontur = value;
        this._toBool(value)
            ? (this._main.addEventListener('click', this._polygonClickHandler),
               this._main.addEventListener('mousemove', this._polygonHoverHandler),
               this._main.addEventListener('dblclick', this._polygonDbClickHandler) 
            )
            : (this._main.removeEventListener('click', this._polygonClickHandler),
               this._main.removeEventListener('mousemove', this._polygonHoverHandler),
               this._main.removeEventListener('dblclick', this._polygonDbClickHandler) 
            );
    }

    get height() {
        return this._height;
    }

    set height(value) {
        this._height = value;
        const tmp = Number(value);
        if (tmp) {
            this.style.height = this._setValueUnit(value);
            this._main.setAttribute("height", this._setValueUnit(value));
        }
    }

    get bordergeometry() {
        return this._d;
    }

    set bordergeometry(value) {
        if (this._isValidD(value)) {
            this._d = window._globalParams?.NormalizeGeometry ? "M0,0" + value : value;
            //this.afterInitialize();
            this._path.setAttribute("d", this._d);
            if (this._geometryMode === "init") {
                const viewBox = this.getAttribute("viewBox");
                if (viewBox) this._main.setAttribute("viewBox", viewBox);
                else this.updateBorderGeometry();
                this._geometryMode = "static";
            } else {
                this._geometryMode = "dynamic";
                this.updateBorderGeometry();
            }
            this._resource && (this.resource = this._resource);
        } else {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: i18next.t("polygon_primitive_error"),
                text: String.format(i18next.t("polygon_cannot_set_value"), value, this.id , this.attributes.elname?.value ?? ""),
            });
        }
    }

    updateBorderGeometry() {
        const { x, y, width, height } = this._path.getBBox();
        this._main.setAttribute("viewBox", `${x} ${y} ${width || this.width} ${height || this.height}`);
    }

    _handlePolygonEvent(x, y, eventType = 'click') {
        const point = this._path.ownerSVGElement.createSVGPoint();
        point.x = x;
        point.y = y;
        const matrix = this._path.getScreenCTM().inverse();
        const transformedPoint = point.matrixTransform(matrix);

        if (this._path.isPointInFill(transformedPoint) || this._path.isPointInStroke(transformedPoint)) {

            if (eventType === 'click') {
                this.click();
            } else if (eventType === 'dblclick') {
                this.dispatchEvent(new MouseEvent('dblclick'));
            } else if (eventType === 'mousemove') {
                this._path.style.stroke = this.tryToGetUserColor(this.bordercolorhover);
                this._path.style.strokeWidth = this._borderthicknesshover;
                this.style.zIndex = this._z + 100;
                this.style.cursor = this.getCursor(this._mousecursorkind);
                this.dispatchEvent(new MouseEvent('mousemove'));
            }
        } else if (eventType === 'mousemove') {
            this._path.style.stroke = '';
            this._path.style.strokeWidth = '';
            this.style.cursor = 'default';
            this.style.zIndex = this._z;
            this.dispatchEvent(new MouseEvent('mouseleave'));
        }
    }

    _handlePolygonContur(e) {
        e.stopPropagation();
        const { clientX: x, clientY: y } = e;
        document.elementsFromPoint(x, y).forEach(element => {
            if (element.nodeName === 'MS-POLYGON') {
                element._handlePolygonEvent(x, y, 'click')
            }
        })
    }

    _handlePolygonConturHover(e) {
        e.stopPropagation();
        const { clientX: x, clientY: y } = e;
        document.elementsFromPoint(x, y).forEach(element => {
            if (element.nodeName === 'MS-POLYGON') {
                element._handlePolygonEvent(x, y, 'mousemove')
            };
        })
    }

    _handlePolygonConturDbClick(e) {
        e.stopPropagation();
        const { clientX: x, clientY: y } = e;
        document.elementsFromPoint(x, y).forEach(element => {
            if (element.nodeName === 'MS-POLYGON') {
                element._handlePolygonEvent(x, y, 'dblclick')
            }
        })
    }

    /**
     * Проверка корректности пути для рисования
     * @param {string} value проверяемое значение
     * @return {bool} результат проверки
     */
    _isValidD(value) {
        const regEverythingAllowed = /[MmZzLlHhVvCcSsQqTtAaEe0-9-,.\s]/g;

        const containsIllegalCharacter = !!value.replace(
            regEverythingAllowed,
            ""
        ).length;
        const containsAdjacentLetters = /[a-zA-Z]{3}/.test(value);
        const invalidStart = /^[0-9-,.]/.test(value);
        const invalidEnd = /.*[-,.]$/.test(value.trim());

        return !(
            containsIllegalCharacter ||
            containsAdjacentLetters ||
            invalidStart ||
            invalidEnd
        );
    }

    observePathSize() {
        this.resizeObserver = new ResizeObserver(entries => {
            const { width, height } = entries[0].contentRect;
            if ((width !== this.currentPathWidth || height !== this.currentPathHeight) && (width > 0 || height > 0)) {
                this.currentPathWidth = width;
                this.currentPathHeight = height;
                if (this._geometryMode === "dynamic") this.updateBorderGeometry();
            }
        });
        this.resizeObserver.observe(this._path);
    }

    disconnectedCallback() {
        this.resizeObserver.disconnect();
        super.disconnectedCallback();
    }
}